import { useEffect } from "react";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";

import { ADMIN_LEADS_ENDPOINTS, AdminLeadsService } from "@/service/api/admin-leads";

const useLeadsSummary = () => {
  const query = useQuery({
    queryKey: [ADMIN_LEADS_ENDPOINTS.SUMMARY],
    queryFn: AdminLeadsService.summary,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar totalizadores.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useLeadsSummary;
